var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topic"},[_c('div',[_c('div',{class:[
        'topic__title',
        {
          'topic__title--spacing': _vm.item.tags && _vm.item.tags.length > 0
        }
      ]},[_vm._v("\n      "+_vm._s(_vm.item.name)+"\n    ")]),(_vm.item.tags && _vm.item.tags.length > 0)?_c('b-taglist',_vm._l((_vm.item.tags),function(tag,tagIndex){return _c('b-tag',{key:tagIndex,attrs:{"type":"is-info"}},[_vm._v("\n        "+_vm._s(tag)+"\n      ")])}),1):_vm._e()],1),_c('router-link',{staticClass:"button is-link is-small",attrs:{"to":("/topics/edit/" + (_vm.item.id))}},[_vm._v("\n    Edit\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }